import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProviderService } from '../components/provider/provider.service';
import { EntityService } from '../components/entity/entity.service';
import { LinkService } from './link/services/link.service';
import { LinkElementsDirective } from './link/directives/link-elements.directive';
import { LinkContainerDirective } from './link/directives/link-container.directive';
import { QueryService } from '../services/query.service';
import { PopoverComponent } from './popover/popover.component';
import {
  RteToolbarLiteModule,
  RteMaterialModule,
  RteLibraryModule,
  RteToolbarModule,
  RteTabModule,
  RteAutoCompleteModule,
  RteAppTitleModule,
  RteAlertModule
} from 'rte-library';
import { RteFormModule } from './rte-form/rte-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialBaseModule } from 'src/app/modules/angular-material-base.module';
import { TextMaskModule } from 'angular2-text-mask';
import { MatButtonModule, MatButtonToggleModule, MatMenuModule } from '@angular/material';
import { ReportExportationComponent } from '../components/report-view/report-render/report-exportation/report-exportation.component';
import { ReportNavigationComponent } from '../components/report-view/report-render/report-navigation/report-navigation.component';
import { ShareModuleModule } from './share-dialog/share-module.module';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    RteMaterialModule,
    RteLibraryModule,
    RteToolbarModule,
    RteTabModule,
    RteAutoCompleteModule,
    RteAppTitleModule,
    RteAlertModule,
    RteFormModule,
    TextMaskModule,
    RteToolbarLiteModule,
    ShareModuleModule,
  ],
  declarations: [
    LinkElementsDirective,
    LinkContainerDirective,
    PopoverComponent,
    ReportExportationComponent,
    ReportNavigationComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    RteFormModule,
    LinkElementsDirective,
    LinkContainerDirective,
    PopoverComponent,
    RteMaterialModule,
    RteLibraryModule,
    RteToolbarModule,
    RteTabModule,
    RteAutoCompleteModule,
    RteAppTitleModule,
    RteAppTitleModule,
    RteAlertModule,
    AngularMaterialBaseModule,
    TextMaskModule,
    ReportNavigationComponent,
    ReportExportationComponent,
    ShareModuleModule,
    MatButtonToggleModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ProviderService,
        EntityService,
        LinkService,
        QueryService,
      ]
    };
  }
}

